import './index.css';
import { useMemo } from 'react';
import { getIdsWithNoParentsInSameList } from './collection/treeCollectionHelper.js';
import './collection/treeCollection.js';

const useDisabled = ({ selected, disabled, collection, maxSelected }) => {
    return useMemo(() => {
        const valueIds = getIdsWithNoParentsInSameList(collection, selected);
        if (maxSelected && valueIds.length >= maxSelected) {
            return collection
                .toList()
                .map(({ id }) => id)
                .filter((id) => !selected.includes(id));
        }
        return disabled;
    }, [selected, collection, disabled, maxSelected]);
};

export { useDisabled };
//# sourceMappingURL=useDisabled.js.map
